module.exports = __webpack_public_path__ + "static/media/table-green.e67bb9fa.png";